var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto"},[_c('GotedoSpinnerLoader'),_c('p',{staticClass:"text-center"},[_vm._v("Processing...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }